import styled from 'styled-components';
import colors from '../../../styles/colors';

export const InCallWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export const Center = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  align-items: center;
`;

export const Content = styled.div`
  background: black;
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const BlurButton = styled.button<{ $isVideoBlurred?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    border-radius: 1200px;
    background: transparent;

    ${({ $isVideoBlurred }) => $isVideoBlurred && 'background: rgba(255, 255, 255, 0.2);'}
  }
`;

export const SettingsButton = styled.div`
  position: relative;
  button {
  }
`;

export const SettingsModalTitle = styled.span`
  margin-right: auto;
  color: ${colors.blue['950']};
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const SettingsModal = styled.div`
  position: absolute;
  background: #ffffff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 16px;
  bottom: 65px;
  right: 0;
  width: 240px;
  z-index: 9999;
  left: 50%;
  gap: 16px;
  transform: translate(-50%, 0);
`;

export const DialPadModal = styled.div`
  position: absolute;
  background: #ffffff;
  padding: 20px;
  flex-direction: column;
  border-radius: 16px;
  bottom: 65px;
  right: 0;
  width: 240px;
  z-index: 9999;
  left: 50%;
  transform: translate(-50%, 0);
  display: grid;
  grid-template-columns: repeat(3, 60px);
  grid-template-rows: repeat(5, 60px);
  gap: 16px;
  justify-content: center;

  div {
    height: 100%;
    grid-column: span 3;
    display: flex;
    align-items: center;
    background: transparent;

    input {
      outline: none;
      border: none;
      font-size: 26px;
      text-align: center;
      width: 100%;
    }

    &:hover {
      background: transparent;
    }
  }

  button {
    background-color: #f1eff7;
    border-radius: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    font-weight: 700;
    cursor: pointer;
    color: ${colors.blue['950']};
    transition: all ease-in-out 0.1s;
    &:hover {
      background-color: #e7e4ec;
    }
  }
`;

export const RotateCameraButton = styled.button`
  display: none;
`;

export const Media = styled.div`
  flex: 1;
  position: relative;
  margin: 8px;

  ${BlurButton} {
    display: none;
  }

  @media (max-width: 640px) {
    ${BlurButton} {
      position: absolute;
      left: 24px;
      bottom: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 54px;
      height: 54px;
      outline: none;
      border: none;
      border-radius: 100px;
      transition: 0.15s all ease-in-out;
      background: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.52);
      }
    }

    ${RotateCameraButton} {
      position: absolute;
      right: 24px;
      top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 54px;
      height: 54px;
      background: rgba(0, 0, 0, 0.32);
      outline: none;
      border: none;
      border-radius: 100px;
      transition: 0.15s all ease-in-out;
      cursor: pointer;
      z-index: 9999;

      &:hover {
        background: rgba(0, 0, 0, 0.52);
      }
    }
  }
`;

export const ToggleButton = styled.button<{ $muted: boolean }>`
  background: ${({ $muted }) => ($muted ? 'rgba(255, 255, 255, 0.2)' : 'transparent')};
  border-radius: 1200px;
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  height: 94px;
  background: rgba(10, 10, 15, 0.54);
  border-radius: 12px;

  button {
    width: 48px;
    height: 48px;
    border: none;
    outline: none;
    cursor: pointer;

    svg {
      path {
        transition: all 0.1s ease-in-out;
      }
    }

    &:hover {
      svg {
        path {
          fill: ${colors.grey['200']};
        }
      }
    }
  }
`;

export const Left = styled.div`
  display: flex;
  flex: 1;
`;

export const Disconnect = styled.button``;

export const Middle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  gap: 12px;
  position: relative;

  ${Disconnect} {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 54px;
    width: 54px;
    background: ${colors.red['500']};
    border-radius: 54px;
    transition: all 0.1s ease-in-out;

    svg {
      rotate: 135deg;
      path {
        fill: #ffffff;
      }
    }

    &:hover {
      background: ${colors.red['600']};
    }
  }
`;

export const Right = styled.div<{ $isVideoBlurred: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;

  @media (max-width: 640px) {
    ${BlurButton} {
      display: none;
    }
  }
`;

export const PoweredBy = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  height: 33px;
  color: #fff;
  border-top: 1px solid rgba(83, 87, 117, 1);
  background: rgba(10, 10, 15, 0.54);

  a {
    text-decoration: none;
    color: #fff;
  }
`;

export const RemoteVideo = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  align-items: center;
  object-fit: cover;
  background: black;
  border-radius: 8px;
  background: rgba(10, 10, 15, 0.44);
  position: relative;
  overflow: hidden;

  video {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const LocalVideo = styled.div`
  width: 460px !important;
  height: 240px !important;
  align-items: center;
  position: absolute;
  right: 24px;
  bottom: 24px;
  border-radius: 8px;
  background: rgba(10, 10, 15, 1);
  overflow: hidden;
  

  @media (max-width: 640px) {
    left: 24px;
    top: 24px;
    bottom: unset;
    right: unset;
    width: 75px !important;
    height: 120px !important;

    svg {
      width: 37px;
      height: 37px;
    }
  }

  div {
    width: 100%;
    height: 100%;
    position: relative;

    video,
    canvas {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
